import { render, staticRenderFns } from "./AddImportExport.vue?vue&type=template&id=938b570e&"
import script from "./AddImportExport.vue?vue&type=script&lang=js&"
export * from "./AddImportExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports